import enums from '../enums.js';
import createPropertyOrder from '../create-property-order.js';

const componentNames = ['figure'];
const config = {
  styleProperties: createPropertyOrder(enums.properties.FIGURE_COLOR, 30)
};

export default componentNames.reduce((obj, name) => Object.assign(obj, { [name]: config }), {});
